module.exports = __webpack_public_path__ + "static/img/hospital.74d48d57.png";